import {
  GET_LEADERBOARD_FAIL,
  GET_LEADERBOARD_RESET,
  GET_LEADERBOARD_START,
  GET_LEADERBOARD_SUCCESS,
} from "./constants";
import {GetLeaderboardActions, GetLeaderboardState} from "./types";

const initialState: GetLeaderboardState = {
  loading: false,
  data: undefined,
  error: undefined,
}

const reducer = (
  state = initialState,
  action: GetLeaderboardActions,
): GetLeaderboardState => {
  switch (action.type) {
    case GET_LEADERBOARD_START:
      return {
        ...initialState,
        loading: true,
      }
    case GET_LEADERBOARD_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
      }
    case GET_LEADERBOARD_FAIL:
     return {
        ...state,
        loading: false,
        error: action.error,
      }
    case GET_LEADERBOARD_RESET:
      return {
        ...initialState,
      }
    default:
      return state;
  }
}

export default reducer;
